import React from 'react';
import PropTypes from 'prop-types';
import { CookieBannerHeaderStyles } from './CookieBanner.styles';
import { getCookieLinks } from './utils';

const CookieBannerHeader = ({
    bannerText,
    cookieLinks,
    showSplashPrivacyPolicy,
    showSplashCookieList,
    showCompanyPrivacyPolicy,
    showCompanyCookiePolicy,
}) => {
    const styles = CookieBannerHeaderStyles;

    return (
        <div>
            <div style={styles.titleRow}>
                <div style={styles.title}>{bannerText.title}</div>
            </div>
            <div style={styles.description}>{bannerText.description}</div>
            <div style={styles.links}>
                {getCookieLinks(
                    cookieLinks,
                    showSplashPrivacyPolicy,
                    showSplashCookieList,
                    showCompanyPrivacyPolicy,
                    showCompanyCookiePolicy,
                )}
            </div>
        </div>
    );
};

CookieBannerHeader.propTypes = {
    bannerText: PropTypes.object.isRequired,
    cookieLinks: PropTypes.object,
    showSplashPrivacyPolicy: PropTypes.bool,
    showSplashCookieList: PropTypes.bool,
    showCompanyPrivacyPolicy: PropTypes.bool,
    showCompanyCookiePolicy: PropTypes.bool,
};

CookieBannerHeader.defaultProps = {
    cookieLinks: {},
    showSplashPrivacyPolicy: true,
    showSplashCookieList: true,
    showCompanyPrivacyPolicy: false,
    showCompanyCookiePolicy: false,
};

export default CookieBannerHeader;
